export const translatePT = {
  ACADEMIC_PROGRESS: "Progresso acadêmico",
  ACCEPT_SEQUENCE: "Aceitar sequencia",
  ACTIVE: "Ativo",
  ADD_ANOTHER_LANGUAGE: "Adicionar outra linguagem",
  ADD_EMAIL: "Novo e-mail",
  ADD_LANGUAGE: "Novo idioma",
  ADD_NEW_COMPANY: "Nova empresa",
  ADD_NEW_LINGO: "Adicionar Lingo",
  ADD_NEW_STUDENT: "Novo Aluno",
  ADD_NEW_TICKET: "Novo Ticket",
  ADD_NEW: "Adicionar",
  ADD_TEACHER: "Novo professor",
  ADD_TELEPHONE: "Adicionar Telefone",
  ADD_TO_CONTRACT: "Add ao contrato",
  ADDRESS_PLACEHOLDER: "Endereço",
  ADDRESS: "Endereço",
  ADVANCED: "Avançado",
  ALL_LANGUAGES: "Todos os idiomas",
  ALTERNATIVE_EMAIL: "Email alternativo",
  ANALYTICS: "Analytics",
  APP: "App",
  ASSIGNED_TEACHER: "Professor Selecionado",
  AVAILABLE_PART_CLASSES: "Aulas Extras",
  AVARAGE_RATING: "Classificação média",
  AVERAGE: "Média",
  BACK: "Voltar",
  BALANCED: "Balanceado",
  BASIC: "Básico",
  BILINGUAL: "Bilíngue",
  BILLING_HISTORY: "Histórico de faturamento",
  BILLED_MONTHLY: "faturado mensalmente",
  BIRTH_DATE: "Data de nascimento",
  BTN_ADD_NEW_CONTACT: "Novo contato",
  BTN_ADD_NEW_PLAN: "Adicionar plano",
  BTN_ADD_TEL: "Adicionar telefone",
  BTN_ADD: "Adicionar",
  BTN_BACK: "Voltar",
  BTN_BUY_PLAN: "Comprar novo plano",
  BTN_CANCEL_ALL_CLASS: "Cancelar todas as sequências de aulas",
  BTN_CANCEL_ONLY_CLASS: "Cancelar esta sequência de aulas",
  BTN_CANCEL: "Cancelar",
  BTN_CLASS_SCHEDULED: "Aula Agendada!",
  BTN_CLASS_WITHOUT_TECHER: "Aulas sem professor",
  BTN_CLEAR_SEARCH: "Limpar busca",
  BTN_CLOSE: "Fechar",
  BTN_CONFIRM: "Confirmar",
  BTN_CREATE_ACCOUNT: "Criar minha conta",
  BTN_DAYS_TO_REPEAT_CLASS: "Selecione os dias para repetir as aulas",
  BTN_DELETE: "Apagar",
  BTN_DEMO_CLASS_WITHOUT_TECHER: "Aulas demo sem professor",
  BTN_END_TIME: "Hora de término",
  BTN_ENGLISH: "Inglês",
  BTN_HELLO: "Olá",
  BTN_LOGIN: "Entrar",
  BTN_NEW_CLASS: "Nova aula",
  BTN_NO_CLASSES_FOUND: "Não foram encontradas aulas",
  BTN_NO: "Não",
  BTN_NOT_CANCEL_CLASS: "Ooops! Não quero cancelar minha aula",
  BTN_NUMBER_CLASSES: "Número de aulas",
  BTN_PORTUGUESE: "Português",
  BTN_PROCEED_PAYMENT: "Continuar para pagamento",
  BTN_REGULAR: "Regular",
  BTN_REPEAT_UNITIL: "Repetir até",
  BTN_REQUEST: "solicitada",
  BTN_REVERSE_PAYMENT: "Pagamento reverso",
  BTN_REVERSED_PAYMENT: "Class Reversed",
  BTN_SAVE: "Salvar",
  BTN_SCHEDULE_ADDED: "A sua aula foi adicionada ao seu calendário!",
  BTN_SCHEDULE_CLASS: "Agendar aula",
  BTN_SCHEDULE_NEW_CLASS: "Agendar nova aula",
  BTN_SCHEDULE: "Agendar",
  BTN_SEARCH: "Buscar",
  BTN_SEND: "Enviar",
  BTN_SPANISH: "Espanhol",
  BTN_SPECIFIC: "Específico",
  BTN_START_TIME: "Hora de início",
  BTN_UPCOMING_CLASS: "Próximas aulas",
  BTN_VIEW_ALL: "Ver todos",
  BTN_VIEW_SCHEDULE: "Ver agendamentos",
  BTN_VIEW: "Mais",
  BTN_YES_LOVE: "Sim, amei!",
  BTN_YES: "Sim",
  BULK_ADD_NEW_STUDENT: "Importar aluno",
  BULK_ADD_STUDENT: "Bulk add aluno",
  BULK_RESULTS: "Resultados",
  BUY_MORE_CLASSES: "Comprar Aulas",
  CANCEL_ALL_CLASSES_MESSAGE: "O cancelamento desta aula resultará no cancelamento de todas as aulas listadas acima.",
  CANCEL_ALL_FIXED_CLASSES_MESSAGE:
    'O cancelamento desta aula resultará no cancelamento de todas as aulas listadas acima. Se você deseja cancelar todas as aulas fixas, selecione a opção "Cancelar todas as Aulas"',
  CANCEL_CLASS: "Cancelar aula",
  CANCEL_CLASS_OUT_OF_LIMIT: "ATENÇÃO! Você vai perder a aula",
  CANCEL_DATE: "Data do cancelamento",
  CANCEL_LATER_RATE: "Cancelar, eu vou avaliar mais tarde",
  CANCEL_MESSAGE_REPEAT: "Esta aula programada está definida para repetir",
  CANCEL_MESSAGE_TICKET: "Porque você quer cancelar o seu ticket?",
  CANCEL_MESSAGE: "Por que você quer cancelar sua aula?",
  CANCEL_MESSAGE_OUT_OF_LIMIT:
    "Você está prestes a cancelar sua aula fora do limite de tempo permitido (01 hora), então ela será contada como uma aula dada. Tem certeza que deseja cancelar a sua aula?",
  CANCEL_MY_PLAN: "Cancelar meu plano",
  CANCEL_OPENDED_TICKET: "Cancelar ticket aberto",
  CANCEL_PLACEHOLDER: "Diga-nos porque você deseja cancelar sua aula",
  CANCEL_PLAN_MENSSAGEM_2:
    "apenas para registrar, poderia nos dar uma nota de 1 a 10 sobre a sua experiência com as aulas e método?",
  CANCEL_PLAN_MENSSAGEM: "É uma pena para nós que você esteja indo embora 🙁",
  CANCEL_PLAN: "Cancelar Plano",
  CANCEL_IMMEDIATE: "Cancelamento Imediato",
  CANCEL_IMMEDIATE_MESSAGE: "Ao efetuar o cancelamento imediato, o aluno não poderá realizar mais agendamentos.",
  CANCEL_IMMEDIATE_QUESTION: "Tem certeza de que deseja cancelar imediatamente?",
  CANCEL_TICKET: "Cancelar Ticket",
  CANCEL: "Cancelar ",
  CANCELED_CYCLE: "cancelado",
  CANCELLED_LINGO: "Cancelada pela Lingo",
  CANCELLED: "Cancelada",
  CANCELED: "Cancelada",
  CANCELLED_PLAN: "Plano Cancelado",
  CANCELLED_OUT_lIMIT: "Fora do limite",
  CARD_CLASS_ASSOCIATED: "Programações Associadas",
  CARD_CLASS_ATTENDED: "Esta foi uma aula dada?",
  CARD_CLASS_CANCEL: "Informações do Cancelamento",
  CARD_CLASS_CANCELLED: "Aula cancelada",
  CARD_CLASS_CONFIRMED: "Confirmado",
  CARD_CLASS_CONTENT: "Conteúdo da aula",
  CARD_CLASS_COORDINATOR: "Coordenador",
  CARD_CLASS_DETAILS: "Detalhes da aula",
  CARD_CLASS_DONE: "Aula realizada",
  CARD_CLASS_REASON: "Razão",
  CARD_CLASS_STUDENT: "Aluno",
  CARD_CLASS_TEACHER: "Professor",
  CARD_LIST_CUSTOM_SERVICE: {
    cancelled: "Cancelado",
    inProgress: "Em progresso",
    closed: "Fechado",
    open: "Aberto",
    companyManager: "Gerente da empresa",
    b2b: "B2B",
    student: "Student",
    customerService: "Atendimento ao Cliente",
    teacher: "Professor",
    affiliate: "Afiliado",
    coordinator: "Coordenador",
  },
  CARD_PLAN_CLASS: "Aulas",
  CARD_PLAN_COURSE: "Lingo",
  CARD_PLAN_LEVEL: "Nível",
  CARD_PLAN_SCHEDULE: "Controle de agendamentos",
  CARD_PLAN: "Plano",
  CELLPHONE: "Celular",
  CENCELLED_TICKET: "O seu ticket foi cancelado!",
  CHANCE_PICTURE: "Trocar",
  CHANGE_PASSWORD_DESCRIPTION: "Defina sua nova senha",
  CHANGE_PASSWORD_TITLE: "Mudança de senha",
  CHANGE_PASSWORD: "Alterar Senha",
  CHANGE_PLAN: "Mudar",
  CHANGE: "Alterar",
  CHANGE_CARD_ERROR: "Seu cartão não é compatível. Por favor, tente um cartão diferente.",
  CHANGE_CARD_TITLE: "Mude seu cartão de crédito",
  CHECK_IN: "Check In",
  CHECK_OUR_PLANS: "Experimente grátis",
  CHECK_PASS_PLACEHOLDER: "Sua senha novamente",
  CHECK_PASS: "Repita a senha",
  CHOOSE_LIST_TEACHER: "Escolha uma lista",
  CHOOSE_YOUR_PLAN: "Escolha o seu plano",
  CLASS_CANCELED: "Aula cancelada",
  CLASS_CANCELED_IN: "Aula cancelada em",
  CLASS_CONVERTED: "Aula Convertida",
  CLASS_DETAILS_ACCESS_CLASS: "Acesse a sala de aula",
  CLASS_DETAILS_BEFORE_CLASS: "Antes da aula",
  CLASS_DETAILS_EDIT_CLASS: "Editar aula",
  CLASS_LINK: "Sala de Aula",
  CLASS_RATING: "Avaliação de Aulas",
  CLASS_SCHEDULE_EDIT_MODAL_SUBTITLE: "Edição de aula",
  CLASS_SCHEDULE_MODAL_SUBTITLE: "Agendamento de aula",
  CLASS_SUB_CANCELED: "Cancelada",
  CLASS_SUB_CONFIRMED: "Confirmada",
  CLASS_SUB_DONE: "Realizada",
  CLASS_SUB_NOSHOW: "No Show",
  CLASS_SUB_PENDING: "Pendente",
  CLASS_SUBJECT: "Digite o assunto da Classe",
  CLASS_TITLE: "Título da aula",
  CLASS_TOOL: "Ferramenta de Aula",
  CLASS_TYPE: "Tipo da aula",
  CLASS: "aula",
  CLASSES_TODAY: "Hoje você tem",
  CLASSES: "Aulas",
  CLEAR_FILTERS: "Limpar filtros",
  CLOSED_TICKET: "O seu ticket foi fechado!",
  CLOSED: "Fechado",
  COPIED_CLIPBOARD: "Copiado para a área de transferência",
  CONFIRMED: "Confirmada",
  COMERCIAL_RESPONSIBLE_NAME: "Nome do Responsável Comercial",
  COMERCIAL_RESPONSIBLE: "Responsável Comercial",
  COMMENTS: "Comentários",
  COMMERCIAL: "Comercial",
  COMPANY_INFO: "Companias",
  COMPANY_MANAGER: "Company Manager",
  COMPANY_NAME: "Nome da Empresa",
  COMPANY: "Empresa",
  COMPANYMANAGER: "Company Manager",
  COMPLEMENTARY_EXERCISES: "Exercícios complementares",
  CONFIRM_PASS_INVALID: "Por favor, preencha a confirmação da sua senha!",
  CONFIRMATION: "Confirmação",
  CONGRATULATIONS: "Parabéns",
  CONTACT: "Contato",
  CONTACTS: "Contatos",
  CONTENT: "Conteúdo",
  MY_CONTENT: "Meu conteúdo",
  CONTRACT_NUMBER: "Número do contrato",
  CONTRACT: "Contrato",
  CONTRACTS_INFO: "Contratos",
  COORDINATED_LANGUAGES: "Idioma que coordena",
  COORDINATOR: "Coordenadores",
  COPY: "Copiar",
  COUNTRIES: "Países",
  COUNTRY: "País",
  COUPON_INVALID: "Cupom inválido",
  COUPON_VALID: "Cupom válido",
  COUPON: "Cupom de Desconto?",
  COUPONS_INFO: "Cupons",
  CREATOR_USER_ID: "Usuário",
  CURRENT_TIME: "Hora Atual",
  CREATE_COMMISSION: "Gerar comissão",
  CUSTOMER_SERVICE: "Customer Service",
  CYCLE_NAME: "Nome do ciclo",
  CYCLE: "Ciclo",
  DATA_TIME: "Data e hora",
  DATE_CHANGE_PLAN: "Este plano estará ativo no dia",
  DATE_CREATED: "Criado em",
  DATE_FORMAT: "DD/MM/YYYY",
  DATE: "Data",
  DAY: "Dia",
  DAYS: "Dias",
  DELETE_TEACHER: "Excluir professor ",
  DELETE: "Excluir",
  DEMO_CLASS_CONTENT: "Aula Demo / ",
  DEMO_CLASS_CONTENT1: "Primeira Aula",
  DEMO_CLASS: "Aula Demo",
  DEMO_TYPE: "Tipo de demo",
  DESCRIPTION_MODAL_SEND_METHOLOGY: "O conteúdo da Metodologia foi enviado com sucesso!",
  DESCRIPTION_MODAL_SEND_PROGRESS: "O conteúdo do Progresso acadêmico foi enviado com sucesso!",
  DESCRIPTION_PLAN_EXPIRED: "Seu periodo de avaliação acabou! Compre um novo plano clicando no botão abaixo!",
  DESCRIPTION: "Descrição",
  DICTATION: "Ditado",
  DOCUMENT_NUMBER: "ID Empresa",
  DONE: "Feita",
  DONT_HAVE_ACTIVE_PLAN: "Ah, não! Você não tem nenhum plano ativo 🙁",
  DOUBLE_CLICK: "Duplo clique para mudar",
  DOWNLOAD_APP: "Você está no seu telefone? Baixe nosso aplicativo. Clique aqui!",
  DURATION: "Duração",
  ECONOMIC_GROUP: "Grupo Econômico",
  EDIT_COMPANY: "Alterar empresa",
  EDIT_CLASS: "Alterar",
  EDIT_CONTENT: "Alterar Conteúdo",
  EDIT: "Alterar",
  EMAIL_ERROR: "Email incorreto",
  EMAIL_INVALID: "E-mail inválido, por favor, verifique!",
  EMAIL_PLACEHOLDER: "Seu email",
  EMAIL_REQUIRED: "E-mail Invalid, please check!",
  EMAIL: "Email",
  END_TIME: "Hora de finalização",
  END: "Fim",
  ENGLISH: "Inglês",
  ENTER_COUPON_PLACEHOLDER: "Digite o cupom",
  ENTER_NAME: "Coloque o Nome",
  ENTER_PERCENTAGE_VALUE: "Coloque o valor em %",
  ENTER_TICKET: "Coloque o Ticket",
  ERROR_DIALOG: "Algo errado aconteceu, tente novamente mais tarde.",
  EXCEPTION_TEACHER: "Exceção",
  EXCLUSION_LEVELS: "Níveis de exclusão",
  EXPIRED_ON: "Expira em",
  EXPIRES_ON: "Expira em",
  EXTRA_CLASS_PRICE: "Preço da Classe Extra",
  EXTRA_CLASS_USED_PLURAL: "Aulas extras usadas",
  EXTRA_CLASS_USED_SINGLE: "Aula extra usada",
  EXTRA_CLASS: "Aula Extra",
  EXTRA_CLASSES: "aulas extras",
  EXTRA_EMAIL_PLACEHOLDER: "Outro email",
  EXTRA_EMAIL: "E-mail alternativo",
  FAVORITE_TEACHER: "Favorito",
  FEMALE: "Feminino",
  FIELD_IS_REQUIRED: "Campo {{fieldName}} é obrigatório",
  FILTER: "Filtrar",
  FILTERS: "Filtros",
  FINAL_TEST: "Teste final",
  FIRST_ACESS_TEXT_B2B: "Antes de começar as aulas, complete o seu registro e defina uma nova senha",
  FIRST_ACESS_TEXT: "Antes de começar as aulas, complete o seu registro",
  FIRST_CLASS: "Primeira Aula",
  FOCUS: "Conteúdo",
  FORGET_TITLE: "Recuperar senha",
  FORGOT_PASS: "Esqueceu sua senha?",
  FRENCH: "Francês",
  FREE: "Grátis",
  GENDER: "Sexo",
  GENERATE_REPORT: "Gerar relatório",
  GRADES: "Notas",
  GROUP: "Grupo",
  HAVE_ACCOUNT: "Usuário já cadastrado?",
  HISTORY: "Histórico",
  HOME: "Home",
  HOURS: "Horas",
  HOW_MANY_CLASSES: "Quantas Aulas",
  I_AGREE: "Eu aceito",
  I_WANT_TO_SCHEDULE_MY_CLASSES: "Eu Quero Agendar Minhas Aulas",
  IN_PROGRESS: "Em Progresso",
  IN_STOCK: "em estoque",
  IN_THIS_TIMEZONE: "Neste Fuso Horário",
  INACTIVE: "Inativo",
  INDEX_KEY_ERROR: "pt_BR",
  INDEX_KEY_STRING: "namePortuguese",
  INTERMEDIATE: "Intermediário",
  INVALID_FORM_DESCRIPTION: "Preencha as informações obrigatórias e tente novamente.",
  INVALID_FORM_TITLE: "Alerta!",
  INVOICE: "Fatura",
  ISACTIVE: "Ativo",
  ITEM_ACCOUNT: "Minha Conta",
  ITEM_CUSTOMER_SERVICE: "Serviço ao cliente",
  ITEM_SCHEDULE: "Agendamentos",
  ITEM_STUDENTS: "Alunos",
  ITEM_TEACHERS: "Professores",
  LANGUAGE_KEY_STRING: "portuguese",
  LANGUAGE_LEVEL: "Nível do idioma",
  LANGUAGE: "Idioma",
  LANGUAGES: "Idiomas",
  LAST_INTERACTION: "Última Interação",
  LEGAL_NAME: "Razão Social",
  LEVEL_BY_STUDENT: "Nível pelo Estudante",
  LEVEL_SCORE: "Nível e Notas",
  LEVEL: "Nível",
  LEVELS: "Níveis",
  LINGO_ADV: "Avançado",
  LINGO_EMAIL: "Email Cadastrado ",
  LINGO_INTER: "Intermediário",
  LINGO: "Lingo",
  LINK_SUBSCRIPTION: "https://www.lingofor.me/lingo-pt/lingo_aula_demo.html",
  LIST: "Lista",
  LOAD_MORE: "Mostar mais",
  LOCAL_CLASS_TIME: "Horário da aula",
  LOCALE: "pt-br",
  LOGIN_EMAIL: "E-mail para login",
  LOGIN_SUBS: "Inscrever-se",
  LOGOUT: "Sair",
  MALE: "Masculino",
  MANAGE: "Gerenciar Plano",
  MANAGE_ACCOUNT_TITLE: "Minha Conta",
  MANAGE_HOURS_NOTIME: "Nenhum intervalo de tempo disponível para programação neste dia",
  MANAGE_HOURS_TITLE: "Gerencie os seus horários de disponibilidade para cada dia da semana",
  MAXIMUM_STUDENTS: "O limite máximo de alunos por limite de plano alcançado",
  MESSAGE_BACK_RESET_CYCLE: "Os jobs são asíncronos e pode levar alguns minutos para terminar.",
  MESSAGE_EDIT: "Editado",
  MESSAGE_INFO_BILINGUE_NATIVO: `Ao selecionar "Nativo" todos os seus novos agendamentos de aulas de Inglês serão com professores nativos. Ao selecionar "Bilíngue" você terá professores bilíngues.`,
  MESSAGE_INFO_CONTENT_REGULAR: `Regular: O professor seguirá nossa metodologia e materiais que lhe permitirão avançar em nossos diferentes níveis de estudo.`,
  MESSAGE_INFO_CONTENT_SPECIFIC: `Específica: O professor poderá ajudá-lo com qualquer material que você fornecer e assim você poderá esclarecer dúvidas específicas, por exemplo, escrever um e-mail, entender um documento, etc.`,
  MESSAGE_INFO_REPEAT: `Nesta opção você pode repetir o agendamento selecionando os dias e até que data o agendamento seja repetido.`,
  MESSAGE_CONFIRM_CHANGE_CLASS:
    "Como a sua aula começa em menos de 1 hora, fazer alterações neste momento conta como um cancelamento tardio.\nSe você continuar:\nSua aula atual será cancelada e descontada dos seus créditos mensais.\nO novo horário de aula será agendado como uma sessão adicional.",
  MESSAGE_LANGUAGE: "pt_BR",
  MESSAGE_MODAL_VERSION:
    "Fizemos uma nova atualização e precisamos desconectar você para aplicá-la. Por favor faça login novamente.",
  MESSAGE_RESET_CYCLE: "Deseja realmente resetar os ciclos?",
  MESSAGE_SAVE: "Cadastrado",
  METHODOLOGY: "Metodologia",
  MODAL_RELOAD_MESSAGE: "Você mudou seu fuso horário, faça o login novamente!",
  MODAL_RELOAD_SUBJECT: "Fuso horário alterado",
  MODAL_RELOAD_SUBJECT_TIME: "Formato do horário modificado",
  MODAL_RELOAD_MESSAGE_TIME: "Faça login novamente por favor",
  MODULE: "Agendamento",
  MONEY_FORMAT: "US$",
  MONTH: "Mês",
  MONTHLY: "por mês",
  MULTYPLE_CLASSES_MESSAGE:
    "Esta aula faz parte de um agendamento múltiplo. Ao aceitá-lo, você será atribuído a toda a sequência:",
  MULTYPLE_CLASSES: "Múltiplas Aulas",
  NAME_PLACEHOLDER: "Seu nome",
  NAME_REQUIRED: "Por favor, preencha seu nome!",
  NAME: "Nome",
  NATIVE_LANGUAGE: "Idioma nativo",
  NATIVE: "Nativo",
  NEW_BTN_RESET_CYCLE: "Resetar ciclos",
  NEW_CONTENT: "Novo Conteúdo",
  NEW_USER: "Não é cadastrado?",
  NEW: "Novo",
  NIVEL_A0: "Iniciante",
  NIVEL_A1: "Pré-básico",
  NIVEL_A2: "Básico",
  NIVEL_B1: "Intermediário",
  NIVEL_B2: "Intermediário Superior",
  NIVEL_C1: "Avançado",
  NIVEL_C2: "Proficiência",
  NIVEL_DM: "Manutenção",
  INTERVIEW: "Entrevista",
  NO_NOTIFICATIONS: "Sem Notificações",
  NO_RESULTS: "Sem resultados",
  NO_THANKS: "Não Obrigado",
  NO: "Não ",
  NOSHOW_MESSAGE_MODAL: "A aula mudará de status para {{status}}, deseja continuar?",
  NOSHOW: "Faltou",
  NOT_AUTHORIZED: "Login não autorizado",
  NOT_INFORMED: "Não informado",
  NOT_REGISTERED: "Não registrado?",
  NOTES_HISTORY: "Histórico de Notas",
  NOTIFICATION_SETTINGS: "Configurações de Notificação",
  NOTIFICATION_TITLE: "Controle onde você receberá notificações da Lingo:",
  NOTIFICATION: "Notificações",
  NOTIFICATIONS: "Notificações",
  O_K: "Ok",
  OBSERVATION: "Observação",
  OCCUPATION: "Ocupação",
  OOOPS_CANCEL_MY_PLAN: "Ooops! Não quero cancelar o meu plano...",
  OOOPS_DONT: "Ooops! Eu não quero cancelar o meu ticket",
  OPEN_DATE: "Data de Abertura",
  OPEN_NEW_TICKET: "Abrir Novo Ticket",
  OPEN: "Aberto",
  OPTION_CORRECTIONS_RATING_COMMENTS: "Só me faz ler sem interação",
  OPTION_EXPLAIN_RATING_COMMENTS: "Fala excessivamente minha língua nativa",
  OPTION_EXPRESSION_RATING_COMMENTS: "Explicações pouco claras dificultam a compreensão",
  OPTION_LOUD_RATING_COMMENTS: "Sinto-me melhor conectado com os outros",
  OPTION_OTHER_RATING_COMMENTS: "Outro",
  OPTION_TALK_RATING_COMMENTS: "Fala rápido e não corrige erros",
  OPTIONS: "Opções",
  OR_LOGIN_TXT: "ou entre com",
  OR_LOGIN: "Ou faça login com",
  ORAL: "Oral",
  ORDER_COMPLETE: "Confirmação",
  ORDER_DETAILS: "Detalhes da compra",
  ORDER_REVIEW: "Revisão & Pagamento",
  ORDER: "Ordem",
  OTHER_LANGUAGE: "Outro idioma",
  OTHER_LANGUAGES: "Outros idiomas",
  PARAMETERS: "Parâmetros",
  PASS_ERROR: "Campo obrigatório",
  PASS_INVALID_MESSAGE:
    "Senha inválida! Mínimo de seis caracteres, pelo menos uma letra, um número e um carácter especial como @$!%*#?&[]{},.;<>:/~^´`-_() !",
  PASS_INVALID: "Por favor, preencha sua senha!",
  PASS_NOT_MATCH: "As senhas e sua confirmação não são iguais, verifique.",
  PASS_NOTEQUAL_MESSAGE: "Os campos de senha devem ser iguais!",
  PASS_PLACEHOLDER: "Sua senha",
  PASSWORD_CHANGE: "Senha alterada com sucesso!",
  PASSWORD_CONFIRM: "Confirmação de senha",
  PASSWORD_ERROR: "Login ou senha inválidos",
  PASSWORD_NOT_MATCH: "As senhas precisam ser idênticas",
  PASSWORD: "Senha",
  PAYMENT_ID: "Pagamento ID",
  PAYMENT_METHOD: "Método de pagamento",
  PAYMENT: "Pagamento",
  PENDING: "Pendente",
  PER_MONTH: "por mês",
  PERIOD_END: "Período - fim",
  PERIOD_START: "Período - início",
  PERIOD: "Período",
  PERSONAL_DATA: "Dados Pessoais",
  PERSONAL_INFO: "Informações pessoais",
  PERSONAL_INFORMATION: "Informação Pessoal",
  PHONE_PLACEHOLDER: "Telefone",
  PHOTO: "Foto",
  PLAN_BALANCED: "Balanceado",
  PLAN_BUSINESS: "Negócios",
  PLAN_BUY: "Comprar plano",
  PLAN_CONVERSATIONAL: "Conversação",
  PLAN_DOWNGRADE: "Baixe meu plano",
  PLAN_GRAMMAR: "Gramatical",
  PLAN_NOT_FOUND: "Plano não encontrado",
  PLAN_RENOVATION: "Reverter cancelamento",
  PLAN_RENOVATION_MESSAGE:
    "Ao reverter o cancelamento, o sistema continuará com a cobrança mensal automática para o seu próximo período de aula.",
  PLAN_TRADITIONAL: "Tradicional",
  PLAN_UPGRADE: "Aumentar meu plano",
  PLAN: "Plano",
  PLANS_AND_PRICING: "Planos e Preços",
  PLANS: "Planos",
  PLEASE_TELL_CANCEL_MESSAGE_TICKET: "Escreva porque você quer cancelar o seu ticket",
  PORTUGUESE: "Português",
  POWER: "Power",
  PRICE_IN: "Preços em US$",
  PROCEED_TO_PAYMENT: "Seguir para o pagamento",
  PROFILE: "Perfil",
  PROVIDER: "Fornecedor",
  PUSH: "Push",
  PUSH_GENERATOR: "Gerator de push",
  RANDOM: "Aleatório",
  RATE: "Avaliar",
  RATING_AVG_INFO: "Avaliação",
  RATING_CONFIRMED: "Avaliada",
  RATING_DESCRIPTION_TEACHER: "Você gostaria de ter mais aulas com esse professor?",
  RATING_INFO_PLURAL: "Avaliações",
  RATING_INFO_SINGULAR: "Avaliação",
  RATING_MODAL_TITLE: "Por favor, avalie as aulas listadas abaixo",
  RATING_PENDING_INFO_PLURAL: "pendentes",
  RATING_PENDING_INFO_SINGULAR: "pendente",
  RATING_PENDING: "Pendente",
  RATING: "Avaliação",
  REAL_LEVEL: "Nível Real",
  REFER_YOUR_FRIENDS_AND_EARN: "O programa Indique e Ganhe alcançou um novo recorde de pagamentos!",
  REFUND: "Reembolso",
  REFUND_MESSAGE: "Ao efetuar o reembolso, o aluno receberá o reembolso do último pagamento.",
  REFUND_QUESTION: "Tem certeza que deseja fazer o reembolso?",
  REMEMBER_ACCESS: "Lembre-me",
  REPEAT: "Deseja repetir esse agendamento em outros dias?",
  REPORT: "Relatório",
  REQUESTED_PLAN: "Plano Requisitado",
  REQUIRED_FIELD: "Obrigatório",
  REQUIRED: "Obrigatório",
  RESET_CYCLE: "no próximo ciclo de reinicialização",
  RESETS_ON: "Reinicia",
  RESIDENCIAL: "Residencial",
  RESEND: "Reenviar",
  REVIEW_AND_PAY: "Conferir & Pagar",
  REVIEW_INFORMATION: "Revise as informações",
  REVIEW_PLAN: "Revise o seu plano",
  REVIEW_YOUR: "Confira Suas ",
  SAVE_FORM_DESCRIPTION: "Informações salvas com sucesso!",
  SAVE_FORM_TITLE: "Sucesso!",
  SAVE: "Salvar",
  SCHEDULE: "Calendário",
  SCHEDULING_CONTROL: "Controle de Agendamento",
  SEARCH_USER: "Busca por usuário",
  SELECT_LANGUAGE_LEVEL: "Por favor, selecione seu nível do idioma desejado",
  SELECT_LANGUAGE_PLAN_TITLE: "Selecione o idioma do plano:",
  SELECT_LANGUAGES: "Por favor, selecione a lingua desejada",
  SELECT_TEACHER: "Selecione um professor",
  SELECT_TIME_FORMAT: "Selecione o formato do horário",
  SELECT_TIMEZONE: "Escolher o Fuso Horário",
  SELECT_THE_LINK: "Selecione o link que deseja enviar:",
  SELECT: "Selecionar",
  SEND: "Enviar",
  SEQUENTIAL_CLASS_MESSAGE: "Esta aula faz parte da seguinte sequência de aulas:",
  SETTINGS_NOTIFY: "Configurações de Notificação",
  SETTINGS: "Configurações",
  SHARE: "Siga-nos",
  SHCEDULING_IN: "Agendado no",
  SHOWING_OF: "de",
  SHOWING: "Mostrando",
  SIGN_UP: "Confira nossos planos",
  SIGNATURE_DATE: "Data de assinatura",
  SIGNATURE_PENDING: "Assinatura pendente",
  SINCE: "Desde",
  SING_IN: "Faça Login",
  SOCIAL_MEDIA: { LOGIN_ERROR: "Falha ao tentar logar" },
  SOMETHING_WENT_WRONG: "Algo parece errado",
  SPANISH: "Espanhol",
  START_TIME: "Hora de início",
  START: "Início",
  STATUS_CHANGE: "Mudança de status",
  STATUS: "Status",
  STRUCTURE: "ESTRUTURA",
  STUDENT_ADDRESS: "Endereço do Estudante",
  STUDENT_COMPANY_NAME: "Nome da Empresa do Estudante",
  STUDENT_COMPANY: "Nome da Empresa",
  STUDENT_EMAIL: "Email do Estudante",
  STUDENT_LINK: "Link do aluno",
  STUDENT_MESSAGE_EDIT: "Aluno editado",
  STUDENT_MESSAGE_SAVE: "Aluno cadastrado",
  STUDENT_NAME: "Nome do Estudante",
  STUDENT_OCCUPATION: "Cargo do Estudante",
  STUDENT_PHONE: "Telefone do Estudante ",
  STUDENT_TOOL_ID: "ID do Estudante",
  STUDENT: "Estudante",
  STUDENTS_TIMEZONE: "Fuso Horário do Estudante",
  STUDENTS: "Alunos",
  SUBSCRIPTION: "Inscrição",
  SUBSCRIPTION_DATE: "Data de assinatura",
  SUBTYPE: "Subtipo",
  SUCCESS_MESSAGE: "Sucesso!",
  SUCCESS_CHANGE_CARD: "Seu cartão foi atualizado, o próximo pagamento será descontado dele.",
  SUCESS_CANCEL_PLAN: "Seu plano foi cancelado. Você poderá agendar aulas até o final do seu ciclo.",
  SUCESS_CANCEL_PLAN_MANAGE: "Plano foi cancelado.",
  SWARMING_TITLE: "Alta Demanda de Aulas",
  TARGET_CLASSES_PER_MONTH: "Target classes per month",
  TEACHER_AVERAGE_RATING: "Média do Professor",
  TEACHER_LINK: "Link do professor",
  TEACHER_NAME: "Nome do Professor",
  TEACHER_TYPE: "Tipo de Professor",
  TEACHER: "Professor",
  TEACHERS: "Professores",
  TEL_REQUIRED: "Número inválido, tente novamente",
  TELEPHONE_COMMERCIAL: "Telefone Comercial",
  TELEPHONE_MOBILE: "Celular",
  TELEPHONE: "Telefone",
  TELL_US_CANCEL_MY_PLAN: "Por favor escreva o motivo do cancelamento",
  TERMS_OF_USE: "Online Learning Agreement",
  TERMS_OF: "os termos de uso",
  THIS_PLAN: "Este plano será",
  TICKET_ID: "Ticket #",
  TICKET_MESSAGE: "O ticket foi criado!",
  TICKET_NUMBER: "Número do Ticket",
  TICKET_TITLE: "Parabéns!",
  TICKET_VIEW: "Abrir ticket",
  TICKETS: "Tickets",
  TIME_SLOT_DURATION: "Duração do intervalo",
  TIMEZONE: "Fuso horário",
  TITLE_CONFIRM_CHANGE_CLASS: "Aviso Importante: Política de Reagendamento Tarde",
  TITLE_MODAL_SEND: "Sucesso!",
  TITLE_MODAL_VERSION: "Nova versão disponível!",
  TITLE_PLAN_EXPIRED: "Seu plano expirou!",
  TITLE: "Título",
  TODAY: "Hoje",
  TOOL_ID: "ID da Ferramenta",
  TOTAL_CLASSES: "Total de aulas",
  TOTAL_CYCLES: "Total de ciclos",
  TOTAL_QUIZZES: "Total de quizzes",
  TRAINING: "Treinamento",
  TRANSACTION_ID: "ID da transação",
  TRIAL_CLASS: "Aula de Avaliação",
  TRY_AGAIN: "Tente novamente",
  TYPE_MESSAGE: "Digite a mensagem...",
  TYPE: "Tipo",
  UNITARY_VALUE: "Valor Unitário",
  UNTIL: "Até",
  UPDATE_SCREEN: "Atualizar",
  USER_INFO: "Seus dados",
  USERS: "Usuários",
  VALID_FORM_DESCRIPTION: "Senha alterada com sucesso!",
  VALID_FORM_TITLE: "Sucesso",
  VALIDATE_SCHEDULE_DATE_PAST: "A data não pode ser passada",
  VALIDATE_SCHEDULE_DATE: "É necessário selecionar uma data",
  VALIDATE_SCHEDULE_FOCUS: "É necessário selecionar o conteúdo",
  VALIDATE_SCHEDULE_LANG: "É necessário selecionar o idioma",
  VALIDATE_SCHEDULE_NATIVE_BILINGUE:
    "A opção nativo/bilíngue não foi selecionada, é necessário escolher o tipo de professor para esta aula",
  VALIDATE_SCHEDULE_NUM_CLASSES: "É necessário selecionar o número de aulas",
  VALIDATE_SCHEDULE_PLAN: "É necessário selecionar o plano",
  VALIDATE_SCHEDULE_REPEATEND: "É necessário selecionar uma data final para a recorrência",
  VALIDATE_SCHEDULE_START: "É necessário selecionar um horário de início",
  VALIDATE_SCHEDULE_WEEKREPEAT: "É necessário selecionar ao menos um dia para recorrência",
  VALIDATE: "Validar",
  VALIDATION_ERROR: "Erro de validação",
  VALUE: "Valor",
  VIEW_MORE: "Ver mais",
  VIEW: "Ver",
  VIEW_CONTRACT: "Ver contrato",
  WEBSITE: "Site",
  WEEK: "Semana",
  WEEK_FRIDAY: "Sexta-feira",
  WEEK_MONDAY: "Segunda-feira",
  WEEK_SATURDAY: "Sábado",
  WEEK_SUNDAY: "Domingo",
  WEEK_THURSDAY: "Quinta-feira",
  WEEK_TUESDAY: "Terça-feira",
  WEEK_WEDNESDAY: "Quarta-feira",
  WELCOME_TITLE: "Bem vindo a ",
  WHAT_TYPE_OF_TEACHER: "Qual o tipo de professor que você deseja ter nessa aula?",
  WHATSAPP: "WhatsApp",
  WHATSAPP_SUPPORT: "Suporte WhatsApp",
  WITHOUT_TEACHER: "Sem professor",
  WORDOFTHEDAY: "Palavra do dia",
  WRITING: "Escrita",
  YES: "Sim ",
  YOUR_EXTRA_CLASS_IS_NO_SET: "A Compra Das Suas Aulas Extras Não Foi Concluida",
  YOUR_EXTRA_CLASSES_IS_ALL_SET: "Suas Aulas Extras Estão Prontas",
  YOUR_PLAN: "Seu plano será",
  YOUR_TIMEZONE: "Seu Fuso Horário",

  PRODUCTIVITY: "Produtividade",
  SALES_LINK: "Link de Indicação",
  DISCLOSURE: "Divulgação",
  TRANSACTIONS: "Transações",
  CONTRACTS: "Contratos",
  BRONZE: "Bronze",
  BLUE: "Blue",
  GOLD: "Gold",
  SILVER: "Silver",
  PLATINUM: "Platinum",
  SALES: "indicações",
  SALES1: "Indicações",
  PRIVILEGE: "Privilégio",
  PRIVILEGES: "Privilégios",
  CONTRACT_PENDING: "Seu contrato está pendente",
  MONTHLY_PRIVILEGES: "Os privilégios são mensais",
  PRODUCTIVITYINFO1: "Você precisa de",
  PRODUCTIVITYINFO2: "indicações para atingir o nível",
  MY_TRANSACTIONS: "Minhas transações",
  MY_COMMISSION: "Minha comissão",
  MINIMUM_WITHDRAWAL1: "Mínimo de",
  MINIMUM_WITHDRAWAL2: "para retirada",
  VISITS: "Visitas",
  DEMOS: "Demos",
  CONVERSIONS: "Conversões",
  FLAT: "Plano",
  MENU: "Menu",
  MY_SALES_LINK: "Meu link de indicações",
  SHORT_LINK: "Link curto",
  SHARE_SOCIAL_NETWORKS: "Compartilhe nas redes sociais",
  LINK_COPIED: "Link copiado para área de transferência.",
  MESSAGE_SHARE: "Teste mensagem lingo",
  CURRENT_BALANCE: "Saldo atual",
  CONCLUDED: "Concluído",
  WITHDRAWAL: "Retirada",
  PAYMENTO_LINGO: "Pagamento Lingo",
  COMMISSION: "Comissão",
  CONVERSION: "Conversão",
  SUBTITLE: "Legenda",
  SUBTITLE_COMMISSION: "Valor vs Tempo",
  SUBTITLE_CONVERSION: "Indicações vs Tempo",
  AFFILIATE: "Afiliado",
  AFFILIATES: "Afiliados",
  ADD_PROFILE_PHOTO: "Adicione uma foto de perfil.",
  ADD_TAX_INFORMATION: "Adicione suas informações fiscais.",
  ADD_PAYMENT_INFORMATION: "Selecione um método de pagamento",
  TERMS_OF_USE_AFFILIATE: "Termos de uso",
  BTN_ACCEPT: "Concordo",
  PROFILE_PICTURE: "Foto de perfil",
  SUCCESS_MESSAGE_PHOTO: "Sua foto foi adicionada com sucesso!",
  PAYMENT_METHOD_LABEL: "Insira o método e o usuário da conta",
  SUCCESS_MESSAGE_PATMENT_METHOD: "Seus detalhes de pagamento foram adicionados com sucesso!",
  FISCAL_DOCUMENT: "Qual é o seu documento fiscal?",
  OTHER: "Outro",
  BRAZILIAN_ADDRESS: "Endereço brasileiro",
  AMERICAN_ADDRESS: "Endereço americano",
  ADRESSE_COLOMBIENNE: "Endereço colombiano",
  ADRESSE_MEXICAINE: "Endereço mexicano",
  ALERT_TAX_INFORMATION:
    "Importante: Você selecionou a opção para residentes fiscais dos Estados Unidos. Todas as informações devem ver verificadas porque serão usadas para geração de 1099",
  SUCCESS_MESSAGE_TAX_INFORMATION:
    "As informações foram cadastradas de forma satisfatória, o contrato foi enviado para seu e-mail pronto para sua assinatura.",
  ALERT_MESSAGE_TAX_INFORMATION: "O contrato foi enviado para seu e-mail pronto para sua assinatura.",
  TAX_INFORMATION: "Informações Fiscais",
  CITY: "Cidade",
  STATE: "Estado",
  ZIPCODE: "CEP",
  CITIZENSHIP_COUNTRY: "Qual país da sua cidadania?",
  WHERE_LIVE_COUNTRY: "Qual o país onde reside?",
  MODAL_PAYAMENT_ALERT01: "Digite o e-mail que você usa para fazer login na plataforma de pagamento selecionada. ",
  MODAL_PAYAMENT_ALERT02: "Importante: ",
  MODAL_PAYAMENT_ALERT03:
    " você deve conferir o email, já que uma vez processado o pagamento não temos como solicitar estorno.",
  SALES_LINK_PT: "Link em português",
  SALES_LINK_ES: "Link em espanhol",
  SALES_LINK_US: "Link em inglês",
  BONUS: "Bônus",
  CORPORATE_NAME: "Razão Social",
  COMMUNICATION_LANGUAGE: "Idioma de Comunicação",
  PHYSICAL_PERSON: "Pessoa Física",
  LEGAL_PERSON: "Pessoa Jurídica",
  AFFILIATE_PROGRAM_TITLE: "Programa de afiliado ($)",
  AFFILIATE_PROGRAM_DESCRIPTION: "Cadastre-se gratuitamente e comece a receber!",
  BE_AFFILIATED: "Indique e ganhe",
  PAID: "Pago",
  NO_ITEMS_FOUND: "Nenhum item encontrado...",
  TOTAL_LIFETIME_COMMISSION: "Comissão vitalícia total",
  PAY_ALL: "Pague tudo",
  MODAL_AFFILIATE_STUDENT_TITLE1: "Ganhe até ",
  MODAL_AFFILIATE_STUDENT_TITLE2: "$ 75,20 dólares",
  MODAL_AFFILIATE_STUDENT_TITLE3: "por plano contratado",
  MODAL_AFFILIATE_STUDENT_SUBTITLE1: "Seja um dos primeiros afiliados da Lingofor.me",
  MODAL_AFFILIATE_STUDENT_SUBTITLE2: "Gere uma renda extra em dólares!",
  MODAL_AFFILIATE_STUDENT_BUTTON: "Comece agora!",
  MODAL_AFFILIATE_STUDENT_CARD_TITLE1: "1 - Divulgue seu link de indicação",
  MODAL_AFFILIATE_STUDENT_CARD_TITLE2: "2 - Agendamento de aula demo",
  MODAL_AFFILIATE_STUDENT_CARD_TITLE3: "3 - Receba a comissão em dólares",
  MODAL_AFFILIATE_STUDENT_CARD_SUBTITLE1:
    "Compartilhe seu link exclusivo de indicação com amigos, familiares e colegas.",
  MODAL_AFFILIATE_STUDENT_CARD_SUBTITLE2:
    "Todo aluno indicado para o curso, poderá agendar uma aula experimental gratuitamente para conhecer o método e a plataforma.",
  MODAL_AFFILIATE_STUDENT_CARD_SUBTITLE3: "Ganhe comissão de até $75,20 dólares por cada plano contratado.",
  ITEM_CARD_AFFILIATE1: "Pagamento em dólares.",
  ITEM_CARD_AFFILIATE2: "Ganhe comissão de até $75,20 dólares por cada plano contratado.",
  ITEM_CARD_AFFILIATE3: "Pagamentos quinzenais.",
  ITEM_CARD_AFFILIATE4: "Quanto mais pessoas você indicar, maior será a possibilidade de planos contratados.",
  ITEM_CARD_AFFILIATE5: "Indique em qualquer país, temos estudantes em mais de 34 países.",
  ITEM_CARD_AFFILIATE6: "Mais de 400 mil aulas ministradas na plataforma.",
  ITEM_CARD_AFFILIATE7: "Excelente feedback dos alunos",
  ITEM_CARD_AFFILIATE8: "Todos os planos são multilíngues",
  ITEM_CARD_AFFILIATE9: "Planos mensais e sem multa de cancelamento para alunos",
  JANUARY: "Janeiro",
  FEBRUARY: "Fevereiro",
  MARCH: "Março",
  APRIL: "Abril",
  MAY: "Maio",
  JUNE: "Junho",
  JULY: "Julho",
  AUGUST: "Agosto",
  SEPTEMBER: "Setembro",
  OCTOBER: "Outubro",
  NOVEMBER: "Novembro",
  DECEMBER: "Dezembro",
  JAN: "Jan",
  FEB: "Fev",
  MAR: "Mar",
  APR: "Abr",
  JUN: "Jun",
  JUL: "Jul",
  AUG: "Ago",
  SEP: "Set",
  OCT: "Out",
  NOV: "Nov",
  DEC: "Dez",

  CREATE_YOUR_ACCOUNT: "Crie sua Conta",
  NAME_FULL: "Nome Completo",
  BTN_NEXT: "Próximo",
  SELECT_COUNTRY: "Selecione seu país",
  REVIEW_SUBSCRIPTION_TITLE: "Revisar Subscrição",
  ABBREVIATED_DISCOUNT: "Desc.",
  REVIEW_SUBSCRIPTION_TEXT1: "Seu plano é renovado mensalmente de forma automática. Você pode",
  REVIEW_SUBSCRIPTION_TEXT2: "parar a renovação automática a qualquer momento.",
  REVIEW_SUBSCRIPTION_TEXT3: "O valor da mensalidade para o plano escolhido é de",
  REVIEW_SUBSCRIPTION_TEXT4: "cuja cobrança será realizada mensalmente no dia da sua inscrição.",
  PRIVACY_TERMS_TEXT: "Concordo com os termos de renovação automática acima.",
  ALL_OUR_PLANS: "Todos os nossos planos sǎo multilíngues.",
  SIGN_FOR_LINGO: "Ao se inscrever na Lingo, você concorda os termos acime e com nossa",
  PRIVACY_POLICY: "Política de Privacidade",
  BTN_BUY: "Comprar",
  TOTAL: "Total",
  THANKS: "Obrigado!",
  A_PARTNER: "Uma parceira:",
  WELCOME_TO_LINGO: "A compra do seu plano foi concluída com sucesso! Bem-vindo ao Lingo!",
  WELCOME_TO_LINGO_CHANGE: "A compra do seu plano foi concluída com sucesso!",
  BTN_MANAGR_ACCOUNT: "Acessar Plataforma",
  MINUTE_CLASSES_MONTH: "aulas de 30 minutos mensais",
  ITEM_CARD_INFO1: "Planos Multilíngues",
  ITEM_CARD_INFO2: "Aulas Particulares com Professores ao Vivo",
  ITEM_CARD_INFO3: "Aulas Práticas focadas em conversação",
  ITEM_CARD_INFO4: "Agendamento livre (24 horas)",
  ITEM_CARD_INFO5: "Não é cobrado taxa de matrícula, material e não possui multa por cancelamento",
  ITEM_CARD_INFO6: "A cobrança é mensal e automática",
  ITEM_CARD_INFO7: "As aulas não são acumulativas de um período para o outro",
  ITEM_CARD_INFO8: "Apps para",
  INVALID_PASS1: " Ter no mínimo 6 caracteres",
  INVALID_PASS2: " Ter pelo menos 1 letra",
  INVALID_PASS3: " Ter pelo menos 1 número",
  INVALID_PASS4: " Ter pelo menos 1 caractere especial",
  INVALID_PASS5: " As senhas devem ser iguais.",
  INVALID_FORM_CHECKOUT1: "O nome é obrigatório!",
  INVALID_FORM_CHECKOUT2: "O email é obrigatório!",
  INVALID_FORM_CHECKOUT3: "O email é inválido!",
  INVALID_FORM_CHECKOUT4: "O celular é obrigatório!",
  INVALID_FORM_CHECKOUT5: "O país é obrigatório!",
  INVALID_FORM_CHECKOUT6: "Você precisa concordar com os termos de privacidade para continuar.",
  INVALID_FORM_CHECKOUT7: "O usuário",
  INVALID_FORM_CHECKOUT7_1: "já existe, clique no botão de login para inserir seu usuário.",
  INVALID_FORM_CHECKOUT9: "O campo de razão social é obrigatório",
  INVALID_FORM_CHECKOUT10: "O data de nascimento é obrigatório!",
  INVALID_FORM_CHECKOUT11: "Voce precisar ser mais de 18 anos para se cadastrar!",
  INVALID_FORM_CHECKOUT12: "O campo de idioma é obrigatório",
  INVALID_FORM_CHECKOUT13: "Por favor, complete o reCAPTCHA!",

  SAME: "Mesmo",
  BEST_SELLER: "Best Seller",
  CARD: "Cartão",
  NEW_CARD: "Inserir um novo cartão como forma de pagamento.",
  NEXT_CYCLE: "Sua subscrição será alterada na próxima renovação de ciclo de pagamento.",
  ACTIVATION: "Ativação",
  SCHEDULED: "Programada",
  IMMEDIATE: "Imediata",
  CHANGE_NOW: "Sua subscrição será alterada agora mesmo para o novo plano.",

  NEW_MULTI_STUDENT: "NOVIDADE",
  SUBTITLE01: "A partir de agora o seu plano é MULTI-IDIOMAS",
  SUBTITLE02: "Estude Inglês, Espanhol, Português e Francês (em breve), sem pagar mais por isso!",

  TITLE_ALERT_NEWS: "Nova Atualização",
  SUBTITLE01_ALERT_NEWS: "Diga adeus aos post-its e à necessidade de conferir sua agenda duas vezes! 🚀",
  SUBTITLE02_ALERT_NEWS:
    "Nossa novidade chegou: integração completa com o Google Agenda. Agora, suas aulas aparecem magicamente no seu calendário pessoal assim que você cria um novo compromisso.",
  SUBTITLE03_ALERT_NEWS: "✅ Nunca mais se esqueça",
  SUBTITLE04_ALERT_NEWS: "✅ Tudo em um só lugar",
  SUBTITLE05_ALERT_NEWS: "✅ Atualizações em tempo real",
  SUBTITLE06_ALERT_NEWS: `Experimente hoje mesmo! Acesse "Minha conta" > Notificações e conecte sua conta do Google ao Lingo.`,

  REPORT_FORM: "Formulario",
  CLASSES_HELD: "Conteúdo dado",
  CLASS_COMMENTARY: "Comentário",
  EVALUATED: "Preenchido",
  ASSESSED_LATE: "Preenchido com atraso",
  SELECT_STUDENT_LEVEL: "Selecione o nível do aluno",
  STUDENT_PERSONAL_PROFILE: "Conteúdo proposto",
  ADD_SPECIFIC_CLASS: "Adicionar conteúdo específico",
  CLASS_NOT_COMPLETED: "Conteúdo não concluído",
  PAGE: "Página",
  SPECIFY_NEXT_TEACHER: "Especifique onde o próximo professor deve continuar:",
  MORE_CLASSES: "Mais conteúdo",
  COMMUNICATE_SOMETHING_COORDINATOR: "Deseja comunicar algo ao coordenador?",
  ENTER_STATEMENT_HERE: "Digite aqui o comunicado",
  YES_COMMUNICATE: " SIM, quero comunicar!",
  FINISH: "Finalizar",
  NO_FINISH: "Não, apenas finalize!",
  ACCEPT: "Aceitar",
  STUDENT_LEVEL: "Nível do aluno",
  FILL: "Preencher",
  EXPIRES_AT: "Expira em:",
  PENDENT: "Preencher",
  DELAYED: "Preenchido com atraso",
  PAGE_COMMENT_REQUIRED: "Página e comentário obrigatórios.",
  TITLE_ALERT_ADD_CONTENT_SPECIFIC: "Conteúdo Específico",
  DESCRIPTION_ALERT_ADD_CONTENT_SPECIFIC:
    "O conteúdo específico é exclusivamente para classes onde o material do lingofor.me não foi usado ou para classes de nível M1. Tem certeza de que deseja continuar com este tipo de conteúdo?",

  AFTER_CLASS: "Após a aula",
  FILL_FORM: "Preencher formulário",
  FILL_REPORT: "Preencher Formulario",
  PREVIOUS_CLASSES: "Aulas anteriores",
  LATEST_APPOINTMENTS: "Últimos Agendamentos",
  CODE: "Código",
  STUDENT_DESCRIPTION: "Descrição do estudante",
  CLASS_NOT_COMPLETED_CONTINUE: "Aula não concluída. Continuar em:",
  WAITING_TEACHE_UPDATE: "Aguardando atualização do professor",
  CLASS_EXPIRED: "Aula expirada",

  DETAIL: "Detalhe",
  OUT_OF_LIMIT: "fora do limite",
  FORMS_FILL: "formulários a preencher",
  FORM_DETAIL: "Detalhe do Formulário",
  UPCOMING_MATERIALS: "Próximos Materiais",
  FIRST_CLASS_CONTENT:
    "Opa! Sua primeira aula ainda está em andamento ou ainda não foi agendada. Quando ela estiver concluída, você poderá ver seu progresso aqui.",

  TITLE_STUDENT_CONTENT: "O que há de novo no Lingofor.me",
  DESCRIPTION_STUDENT_CONTENT:
    "Agora você poderá acompanhar seu progresso com mais precisão no novo menu de conteúdo. Você terá seus próximos materiais e o histórico do que viu em seus últimos 3 agendamentos.",

  DEPARTMENT: "Departamento",
  REPORT_UPDATE: "Atualização do Relatório",

  LOADING: "Carregando...",
  QUESTIONNAIRES: "Questionários",
  OPEN_MODAL_QUESTIONNAIRES: "Informações pessoais para fins de imigração",
  NO_QUESTIONS_AVAILABLE: "Nenhuma pergunta disponível",
  MESSAGE_ALERT_QUESTIONNAIRES:
    "O questionário a seguir é fundamental para iniciar sua prática para a entrevista de imigração, pois contém todas as suas informações pessoais necessárias para que nossos instrutores as corrijam e verifiquem. Por favor, responda a cada pergunta de forma clara e detalhada.",

  CONNECT_YOUR_GOOGLE_ACCOUNT:
    "Conecte sua conta do Google para sincronizar seus agendamentos com seu Calendário Pessoal.",
  GOOGLE_CALENDAR: "Google Agenda",
  SYNC_YOUR_GMAIL_ACCOUNT: "Sincronize sua conta do Gmail.",
  MICROSOFT_OUTLOOK: "Microsoft Outlook",
  SYNC_WITH_YOUR_OUTLOOK_ACCOUNT: "Sincronize com sua conta Outlook",
  CONNECT: "Conectar",
  CONNECTED: "Conectado",
  CONNECTING: "Conectando",
  GO_TO_NOTIFICATIONS: "Ir para notificações",

  AI_PRACTICE: "Pratique com a AI",
  SUGESTIONS: "Sugestões",
  TYPE_YOUR_SUGGESTIONS: "Digite suas sugestões",

  AI_PRACTICE_TITLE: "Pratique com a AI Lingo",
  AI_PRACTICE_DESCRIPTION: "O Lingo AI irá gerar exercícios personalizados para você praticar fora da sala de aula.",
  AI_PRACTICE_LIST_DESCRIPTION:
    "A lista a seguir mostra os tópicos mais recentes abordados em suas aulas. Você pode selecionar até {{count}} deles e o Lingo AI gerará exercícios de acordo com seu nível para que você possa praticar.",
  AI_PRACTICE_TOPICS_AVAILABLE: "Tópicos disponíveis para prática",
  AI_PRACTICE_TEACHER_RECOMMEND: "O que seus professores recomendam que você pratique...",
  AI_PRACTICE_SELECT_TOPICS: "Selecionar tópicos",
  AI_PRACTICE_MY_HISTORY: "Meu histórico",
  AI_PRACTICE_GENERATE: "Gerar",
  AI_PRACTICE_EMPTY_TITLE:
    "Após a sua primeira aula neste idioma, a opção de gerar exercícios será habilitada para que você possa começar a praticar.",

  MY_HISTORY_EXERCISES: "Exercícios",
  MY_HISTORY_TOPICS: "Tópicos",
  MY_HISTORY_CREATION_DATE: "Data de criação",
  MY_HISTORY_LAST_UPDATE: "Última atualização",
  MY_HISTORY_SCORE: "Pontuação",
  MY_HISTORY_SUGGESTIONS: "Sugestões de AI do Lingo",
  MY_HISTORY_REDO: "Responda aos mesmos exercícios que você já fez e melhore sua nota.",
  MY_HISTORY_GENERATE_NEW: "Gere exercícios novos e diferentes sobre o mesmo tema e pratique mais.",
  MY_HISTORY_NO_ITEMS_FOUND:
    "Você ainda não gerou seus primeiros exercícios. Clique no botão 'Voltar', selecione os tópicos que deseja praticar e clique no botão 'Gerar'.",
  MY_HISTORY_VIEW_RESULTS: "Clique para ver os resultados",

  PREMIUM_PLAN_FOR_MAXIMUM_PROGRESS: "Plano premium para máxima evolução.",
  IDEAL_FOR_RESUMING_YOUR_STUDIES_WITH_EASE: "Ideal para retomar seus estudos com leveza.",
  MORE_FREQUENCY_TO_ACCELERATE_YOUR_PROGRESS: "Mais frequência para acelerar sua evolução.",
};
